import { Config, IContext, Operator, pipe, waitUntil, wait, run } from 'overmind'
import { loadRates, storeRates } from './operators'

export const loadRatesInfinitely: Operator<void, Promise<void>> = pipe(
  wait(1000),
  waitUntil(({ rates }) => rates.shouldLoadRates),
  loadRates(),
  storeRates(),
  run(function loadRatesInfinitely({ actions: { rates } }) {
    void rates.loadRatesInfinitely()
  })
)

export const subscribeToRatesUpdate = (
  { state: { rates } }: IContext<Config>,
  id: string
): void => {
  rates.subscriptionPool = Array.from(new Set([...rates.subscriptionPool, id]))
}

export const unsubscribeFromRatesUpdate = (
  { state: { rates } }: IContext<Config>,
  id: string
): void => {
  rates.subscriptionPool = rates.subscriptionPool.filter((subscriberId) => subscriberId !== id)
}
